export enum RULE_TYPE {
    SCHEDULE = 'schedule',
    STAND_BY_KILLER = 'standByKiller',
    LOW_COST_TARIFF = 'lowCostTariff'
}

export enum RULE_SCHEDULE_TYPE {
    ON_OFF = 'on-off',
    HVAC = 'hvac',
    THERMOSTAT = 'thermostat',
    STAND_BY_KILLER = 'stand-by-killer'
}

export enum SCHEDULE_TYPE {
    ON_OFF = 'ON/OFF',
    HVAC = 'HVAC',
    THERMOSTAT = 'THERMOSTAT',
    ECONOMIC = 'ECONOMIC',
    STAND_BY_KILLER = 'STANDBY KILLER'
}

export class ERROR {
    public static readonly CREATE_SCHEDULE_INVALID_INTERVAL = 'The end time must be greater than the start time.';
    public static readonly CREATE_SCHEDULE_SCHEDULING_CONFLICT = 'Can not override schedules. You have already scheduled:';
}

export enum SchedulingType {
    ON_OFF = 'on/off',
    ECONOMIC = 'economic',
    STANDBY_KILLER = 'standby killer',
    SETPOINT = 'setpoint',
    POWER_LIMIT_CONTROL = 'power limit control'
}

export enum EVENT_COLOR {
    ECONOMIC = '#f68896',
    ON_OFF = '#ea615b',
    HVAC = '#ea615b',
    THERMOSTAT = '#ea615b',
    STAND_BY_KILLER = '#a22528',
    DISABLED = '#9b9b9b',
    DESIRED = 'rgba(255, 255, 255, 0.3)'
}

export enum MODE {
      OFF = 'OFF',
      AUTO = 'AUTO',
      HEAT = 'HEAT',
      COOL = 'COOL',
      DRY = 'DRY',
      FAN = 'FAN',
}

export enum COMMAND {
    ON = 'ON',
    OFF = 'OFF'
}

export enum RULE_STATUS {
    DESIRED = 'desired',
    REPORTED = 'reported'
}








// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling.constants.ts